/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';

type PropTypes = {
    /**
     * Coverage rating 0–4. Determines how many of the five bars are filled.
     * The legacy sarsa icon-sprite version had only 4 bars; this version
     * matches the 5-bar reception-style design.
     */
    value: number;
    /** Visual size hint — kept for back-compat with the old sprite-based API. */
    size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl';
};

const TOTAL_BARS = 4;

export default class CellCoverageIcon extends React.PureComponent<PropTypes> {
    render() {
        const { value, size } = this.props;
        const filled = Math.max(0, Math.min(TOTAL_BARS, Math.round(value)));
        const sizeClass = size ? ` cell-coverage-icon-${size}` : '';

        return (
            <span
                className={`cell-coverage-icon coverage-${filled}${sizeClass}`}
                role="presentation"
            >
                {Array.from({ length: TOTAL_BARS }).map((_, i) => (
                    <span
                        key={i}
                        className={`cell-coverage-icon-bar cell-coverage-icon-bar-${i + 1}${
                            i < filled ? ' cell-coverage-icon-bar-filled' : ''
                        }`}
                    />
                ))}
            </span>
        );
    }
}
